/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventPartyCompInfo,
    JsonEventPartyCompInfoFromJSON,
    JsonEventPartyCompInfoFromJSONTyped,
    JsonEventPartyCompInfoToJSON,
} from './JsonEventPartyCompInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonEventPartyCompInfo
 */
export interface ApiResultOfListOfJsonEventPartyCompInfo {
    /**
     * 
     * @type {Array<JsonEventPartyCompInfo>}
     * @memberof ApiResultOfListOfJsonEventPartyCompInfo
     */
    data?: Array<JsonEventPartyCompInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyCompInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonEventPartyCompInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyCompInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonEventPartyCompInfo
     */
    result?: ApiResultOfListOfJsonEventPartyCompInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonEventPartyCompInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonEventPartyCompInfoFromJSON(json: any): ApiResultOfListOfJsonEventPartyCompInfo {
    return ApiResultOfListOfJsonEventPartyCompInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonEventPartyCompInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonEventPartyCompInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonEventPartyCompInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonEventPartyCompInfoToJSON(value?: ApiResultOfListOfJsonEventPartyCompInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonEventPartyCompInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

